import {Modal,message } from 'antd';
import { allMenu } from '../utils/menu' //左侧菜单数据
import moment from 'moment'
import { getHashParam } from '../utils/NHCore' 
import NHFetch from '../utils/NHFetch' 
var querystring = require('querystring');//将POST请求参数转换请求字符串

export const RECEIVE_USERINFO = 'RECEIVE_USERINFO'



export const receiveUserInfo = (user) => {
    return {
        type:RECEIVE_USERINFO,
        data:user
    }
}

export const userLogin = (params,func) => {
    fetch("login", {
        method:"POST",
        credentials:"include",
        headers:{
            "Content-Type":"application/x-www-form-urlencoded",
            "X-Requested-With":"XMLHttpRequest",
        },
        body:querystring.stringify(params)
    })
        .then((response) => response.json())
        .then((res) => {
            if(res.meta && res.meta.statusCode=='200'){
                if( window.gateway_version === '2' ) {
                    fetch("api/authc/users/current/authority",{
                        method: "GET",
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            "X-Requested-With": "XMLHttpRequest",
                        }
                    })
                    .then((response2) => response2.json())
                    .then(res2=>{
                        if (res2.meta && res2.meta.success) {
                            let authorization = {};
                            res2.data.forEach(element => {
                                authorization[element.authorityId] = "";
                            });
                            res.data.menus = handleMenus(authorization);
                            res.data.authorization = authorization;
                            sessionStorage.setItem("userLogin", JSON.stringify(res.data));
                            sessionStorage.setItem('access_token', res.data.accessToken);
                            //刷新token,后续用来刷新token
                            sessionStorage.setItem('refresh_token', res.data.refreshToken);
                            //记录用户最后一次操作时间
                            let userLastOperationTime = moment().format('YYYY-MM-DD HH:mm:ss');
                            sessionStorage.setItem('user_last_operation_time', userLastOperationTime);
                            //跳转到第一个菜单
                            let nextUrl = res.data.menus[0].url;
                            if (res.data.menus[0].children && res.data.menus[0].children.length > 0) {
                                nextUrl = res.data.menus[0].children[0].url;
                            }
                            location.href = '#'+nextUrl;
                        } else {
                            message.error('查询权限信息失败');
                        }
                    })
                } else {
                    res.data.menus=handleMenus(res.data.authorization);
                    sessionStorage.setItem("userLogin",JSON.stringify(res.data));
                    sessionStorage.setItem('access_token', res.data.tokenId);
                    //跳转到第一个菜单
                    let nextUrl=res.data.menus[0].url;
                    if(res.data.menus[0].children && res.data.menus[0].children.length>0){
                        nextUrl=res.data.menus[0].children[0].url;
                    }
                    location.href = '#'+nextUrl;
                }
                
            }else{
                if(func){
                    func();
                }
                message.error(res.meta.message);
            }
            return res;
        })
        .catch((error) => {
            if(func){
                func();
            }
            // 网络请求失败返回执行该回调函数，得到错误信息
            Modal.error({ title: '网络请求异常,请联系管理员', content: error,});
            return error;
        })
}

export const userLogout = () => {
    fetch("logout", {
        method:"GET",
        credentials:"include",
        headers:{
            "Content-Type":"application/x-www-form-urlencoded",
            "X-Requested-With":"XMLHttpRequest",
        }
    })
        .then((response) => response.json())
        .then((res) => {
            if(res.meta && res.meta.statusCode=='200'){
                sessionStorage.removeItem("userLogin");
                sessionStorage.removeItem("access_token");
                if(window.casLogoutUrl && window.casLogoutUrl!=''){
                    window.location=window.casLogoutUrl;
                }else {
                    location.href="#/login"
                }
            }else{
                message.error("退出登陆失败，请稍后再试一次！");
            }
            return res;
        })
        .catch((error) => {
            // 网络请求失败返回执行该回调函数，得到错误信息
            Modal.error({ title: '网络请求异常,请联系管理员', content: error,});
            return error;
        })
}

/**
 * 获取已经登录的用户信息
 * @param func
 */
export const tryLoginUserInfo = (func) => {
    //第一步，清空缓存
    if( window.gateway_version === '2' ) { //新网关

    }  else {
        sessionStorage.removeItem("userLogin");
        sessionStorage.removeItem("access_token");
    }
    
    fetch("tryLoginUserInfo", {
        method: window.gateway_version === '2' ? "GET" : "POST",
        credentials:"include",
        headers:{
            "Content-Type":"application/x-www-form-urlencoded",
            "X-Requested-With":"XMLHttpRequest",
        },
        redirect: 'manual'
    })
        .then((response) => response.json())
        .then((res) => {
            if( window.gateway_version === '2' ) {
                if(res.meta && res.meta.statusCode=='200'){
                    if(res.data){
                        fetch("api/authc/users/current/authority", {
                            method: "GET",
                            credentials: "include",
                            headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                                "X-Requested-With": "XMLHttpRequest",
                            }
                        }).then((response2) => response2.json()).then(res2 => {
                            if (res2.meta && res2.meta.success) {
                                let authorization = {};
                                res2.data.forEach(element => {
                                    authorization[element.authorityId] = "";
                                });
                                res.data.menus = handleMenus(authorization);
                                res.data.authorization = authorization;
                                sessionStorage.setItem("userLogin", JSON.stringify(res.data));
                                sessionStorage.setItem('access_token', res.data.accessToken);
                                //刷新token,后续用来刷新token
                                sessionStorage.setItem('refresh_token', res.data.refreshToken);
                                //记录用户最后一次操作时间
                                let userLastOperationTime = moment().format('YYYY-MM-DD HH:mm:ss');
                                sessionStorage.setItem('user_last_operation_time', userLastOperationTime);
                            } else {
                                message.error('查询权限信息失败');
                            }
                        })
                    }
                }
                sso(func);
                return res;
            } else {
                if(res.meta && res.meta.statusCode=='200'){
                    if(res.data){
                        res.data.menus=handleMenus(res.data.authorization);
                        sessionStorage.setItem("userLogin",JSON.stringify(res.data));
                        sessionStorage.setItem('access_token', res.data.tokenId);
                    }else{
                        sso(func);
                    }
                }
                sso(func);
                return res;
            }
 
        })
        .catch((error) => {
            sso(func);
            // 网络请求失败返回执行该回调函数，得到错误信息
            Modal.error({ title: '网络请求异常,请联系管理员', content: error,});
            return error;
        })
}

//单点登录验证
const sso = (func) => {
    let userLogin = sessionStorage.getItem("userLogin");
    if(userLogin){
        if(func){
            func();
        }
    }else{
        //是否启用单点登录
        if(window.casStatus){
            var urlencode = require('urlencode');
            //跳转至单点登录验证页面
            let hasTicket = window.location.hash.indexOf("ticket") != -1;
            let isGatewayV2 = window.gateway_version === '2';
            if(isGatewayV2&&!hasTicket) { //新网关
                const service = encodeURIComponent(
                    window.location.origin + window.location.pathname + "#/index"
                );
                window.location.href = window.casLoginUrl + "?service=" + service;
            }else if(isGatewayV2&&hasTicket){
                const ticket = getHashParam("ticket");
                const originServiceUrl = window.location.origin + window.location.pathname + "#/index"
                const service = encodeURIComponent(
                    originServiceUrl
                );
                NHFetch("cas/login",'GET',{
                    ticket: ticket,
                    serviceUrl: service
                }).then(res => {
                    // 登录成功，缓存数据跳转到首页
                    if (res.meta && res.meta.statusCode === 200) {
                        fetch("api/authc/users/current/authority", {
                            method: "GET",
                            credentials: "include",
                            headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                                "X-Requested-With": "XMLHttpRequest",
                            }
                        }).then((response2) => response2.json()).then(res2 => {
                            if (res2.meta && res2.meta.success) {
                                let authorization = {};
                                res2.data.forEach(element => {
                                    authorization[element.authorityId] = "";
                                });
                                res.data.menus = handleMenus(authorization);
                                res.data.authorization = authorization;
                                sessionStorage.setItem("userLogin", JSON.stringify(res.data));
                                sessionStorage.setItem('access_token', res.data.accessToken);
                                //刷新token,后续用来刷新token
                                sessionStorage.setItem('refresh_token', res.data.refreshToken);
                                //记录用户最后一次操作时间
                                let userLastOperationTime = moment().format('YYYY-MM-DD HH:mm:ss');
                                sessionStorage.setItem('user_last_operation_time', userLastOperationTime);
                                if(func){
                                    func();
                                }
                            } else {
                                message.error('查询权限信息失败');
                            }
                        })
                        
                    } else {
                        // 登录失败，退出认证登录
                        window.location.href = window.casLogoutUrl + "?service=" + service;
                    }
                });
                
            } else {
                window.location =  window.location.origin + window.location.pathname +'auth?service=' + urlencode(window.location.origin+ window.location.pathname);
            }
            
        }else{
            if(func){
                func();
            }
        }
    }

}


const handleMenus = (auths) => {
    //过滤掉没有权限的菜单
    let leftMenu = filterAuthMenus(allMenu,auths);
    //过滤掉没有子项的菜单
    leftMenu = filteChildrenMenus(leftMenu);
    //一个菜单都没有，说明该用户没有访问这个服务的权限
    if(leftMenu.length<=0){
        leftMenu.push({
            name: '首页',
            key: '403',
            url:'/403',
            icon: 'home',
        });
    }
    return leftMenu;
}

const filteChildrenMenus = (menus) => {
    let fitlerMenus=[];
    menus.map((item,index) => {
        if(item.children){//存在子菜单，只需要处理子菜单即可
            item.children=filteChildrenMenus(item.children);
            if(item.children.length>0){
                fitlerMenus.push(item);
            }
        }else{
            fitlerMenus.push(item);
        }
    });
    return fitlerMenus;
}

const filterAuthMenus = (menus,auths) => {
    let fitlerMenus=[];
    menus.map((item,index) => {
        if(item.children){//存在子菜单，只需要处理子菜单即可
            item.children=filterAuthMenus(item.children,auths);
            fitlerMenus.push(item);
        }else if(item.auth){//存在权限判断，此时需要判断用户是否有该权限
            if(auths[item.auth]!==undefined){
                fitlerMenus.push(item);
            }
        }else{
            fitlerMenus.push(item);
        }
    });
    return fitlerMenus;
}



// WEBPACK FOOTER //
// ./actions/login.js